import React, { useEffect, useState, ChangeEvent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BackButton from '../../components/BackButton';
import { IUser, UserRole, UserColumns } from '../../shared/models/adminModels';
import { GetUser, UpdateUserField } from '../../store/actions/actionTypes';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import TextInput from '../../components/TextInput';
import { IFormState } from '../../shared/models/validations';
import { checkFieldValidation, checkProperties } from '../../services/utilService';
import update from 'react-addons-update';
import { useHistory, Link } from 'react-router-dom';
import { getUser,updateUserProfile } from '../../store/actions/management';
import { get } from 'lodash';

interface IProps {
    user: IUser;
    loggedInUser: IUser;
    isLoading: boolean;
    getUser: Function;
    updateUserField: Function;
    updateUserProfile: Function;
}

const UserProfile = (props: IProps) => {
    useEffect(() => {
        props.getUser(props.loggedInUser.id);
    }, []);
    const history = useHistory();
    const [isEdit, setIsEdit] = useState(false);
    const [userForm, setUserForm] = useState<IFormState>({
        valid: false,
        errors: {},
        validations: {
            [UserColumns.ContactFirstName]: {
                label: 'FirstName',
                required: true,
            },
            [UserColumns.ContactSurName]: {
                label: 'LastName',
                required: true,
            },
            [UserColumns.Email]: {
                label: 'Email',
                required: true,
                email: true
            }
        }
    });
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        props.updateUserField(name, value);
        if (Object.keys(userForm.validations).includes(name)) {
            const error = checkFieldValidation(userForm.validations[name], value);
            setUserForm(update(userForm, {
                errors: {
                    [name]: { $set: error }
                }
            }))
        }
    }

    const checkFormValidation = () => {
        let errors: any = {};
        type IUserForm = keyof IUser;
        Object.keys(userForm.validations).forEach((field: any) => {
            const fieldName: IUserForm = field;
            errors[fieldName] = checkFieldValidation(userForm.validations[fieldName], user[fieldName]);
        });
        return errors;
    }

    const saveUser = async () => {
        const errors = await checkFormValidation();
        const form = {
            ...userForm,
            errors
        }
        setUserForm(form);
        const noError = checkProperties(form.errors);
        if (noError) {
            const params = {
                "id": user.id,
                "email": user.email,
                "contactFirstName": user.contactFirstName,
                "contactSurname": user.contactSurname,
                "jobTitle": user.jobTitle
            };
            const saved = await props.updateUserProfile(params);
            if (saved) {
                setIsEdit(false);
            }
        }
    }

    const { errors } = userForm;
    const { user,loggedInUser } = props;
    const canEdit = get(loggedInUser.permission.manageUserProfile,'edit',false);
    return (
        <div className="container-fluid profile-width-control">
            <div className="page-header">
                <h1>User Profile</h1>
                <BackButton />
                <div className="profile-edit-button mt-3">
                <Link className="change-password" to='/change-password'>Change Password</Link>
                {canEdit && !isEdit && <button type="button" className="btn btn-primary ml-auto" onClick={() => setIsEdit(true)}>Edit</button>
                }
                </div>
            </div>

            <div className="page-content ">
                <div className="row">
                    <div className="profile-card  box-shaddow  border-btm-blue mb-5 w-100">
                        <div className="profile-top">
                            {/* <img src="images/profile-user.png" /> */}
                            <h3 className="mt-5"> {get(user,'contactFirstName','') + ' ' + get(user,'contactSurname','')}</h3>
                            {/* <span className="active-status"></span> */}
                            <div className="permission sim-con">
                                <span className="round blue mr-2"></span>
                                <span className="round blue mr-2"></span>
                                <span className="round blue"></span>
                            </div>
                        </div>

                        <div className="profile-content">
                            
                            <div className="sim-con">
                                        <span>{UserRole[user.userType]}</span>
                            </div>
                            {/* <select className="form-control selectpicker btn btn-light" name="userType" value={user.userType || null} onChange={handleSelectChange}>
                                    {Object.entries(UserRole).map((type) => (
                                        isNaN(Number(type[0])) && <option key={type[1]} value={type[1]}>{type[0]}</option>
                                    ))}
                                </select> */}
                            {!isEdit &&
                                <>
                                   
                                    <div className="sim-con">
                                        <FontAwesomeIcon icon={faEnvelope} />
                                        {/* <i className="fa fa-envelope"></i> */}
                                        <span>{user.email||'-'}</span>
                                    </div>
                                    <div className="sim-con">
                                        <FontAwesomeIcon icon={faShoppingBag} />
                                        {/* <i className="fa fa-envelope"></i> */}
                                        <span>{user.jobTitle||'-'}</span>
                                    </div>
                                </>
                            }
                            {isEdit &&
                                <form>
                                    <div className="form-group">
                                        <label>Email Address</label>
                                        <TextInput placeholder="Email Address" name="email"
                                            value={user.email}
                                            error={errors.email}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>First Name</label>
                                        <TextInput placeholder="First Name" name="contactFirstName"
                                            value={user.contactFirstName}
                                            error={errors.contactFirstName}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Last Name</label>
                                        <TextInput placeholder="Last Name" name="contactSurname"
                                            value={user.contactSurname}
                                            error={errors.contactSurname}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Job Title</label>
                                        <TextInput placeholder="Job Title" 
                                            name="jobTitle"
                                            value={user.jobTitle}
                                            error={errors.jobTitle}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                    <button type="button" disabled={props.isLoading} onClick={() => saveUser()} className="btn btn-primary w-100 mb-2">Save</button>
                                    <button className="btn btn-outline w-100" onClick={() => setIsEdit(false)}>Cancel</button>
                                </div>
                                </form>
                            }
                            <div className="sim-con">
                                {/* <i className="fa fa-envelope"></i> */}
                                <span>Last Login : {moment(user.lastLoginDateTime).format('DD/MM/YYYY hh:mm a')}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return ({
        loggedInUser: state.auth.user,
        user: state.managementReducer.user,
        isLoading: state.common.isLoading
    })
}

const mapDispatchToProps = (dispatch: any) => ({
    getUser: bindActionCreators(getUser, dispatch),
    updateUserProfile: bindActionCreators(updateUserProfile, dispatch),
    setUser: (user: IUser) => dispatch({ type: GetUser, payload: user }),
    updateUserField: (field: string, value: string | number) => dispatch({ type: UpdateUserField, payload: { field, value } }),
});


export default connect(mapStateToProps, mapDispatchToProps)(UserProfile) 
